import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const {
  BackgroundColor,
  HoverBackgroundColor,
  ActiveBackgroundColor,
  OnBackgroundColor,
  OnHoverBackgroundColor,
  OnActiveBackgroundColor,
  TextColor,
  OnTextColor,
  ReceivingCallsIconColor,
} = themeColorSectionKeys.TopNav.DoNotDisturbSplitButton

export const DoNotDisturbSplitButtonStyleValues = {
  menuWidth: '19.5rem',
}

export enum DoNotDisturbSplitButtonVariants {
  DoNotDisturb = 'doNotDisturb',
}

const DoNotDisturbSplitButtonStyleParts = [
  'container',
  'leftButton',
  'rightButton',
  'leftButtonTextWrapper',
  'titleText',
  'subtitleText',
  'doNotDisturbIcon',
  'chevronIcon',
] as const

const helpers = createMultiStyleConfigHelpers(DoNotDisturbSplitButtonStyleParts)

export const DoNotDisturbSplitButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      position: 'relative',
    },
    leftButtonTextWrapper: {
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      marginLeft: '0.5rem',
    },
    leftButton: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 0 0 1.25rem',
      height: '2.5rem',
      width: '10.25rem',
      borderRadius: '1.25rem 0 0 1.25rem',
      backgroundColor: BackgroundColor,
      transition: 'all 0.15s ease-in-out',
      cursor: 'pointer',
      userSelect: 'none',
      _hover: {
        backgroundColor: HoverBackgroundColor,
      },
      _active: {
        backgroundColor: ActiveBackgroundColor,
      },
    },
    rightButton: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 1rem',
      height: '2.5rem',
      width: '3rem',
      marginLeft: '1px',
      borderRadius: '0 1.25rem 1.25rem 0',
      transition: 'all 0.15s ease-in-out',
      cursor: 'pointer',
      userSelect: 'none',
      backgroundColor: BackgroundColor,
      _hover: {
        backgroundColor: HoverBackgroundColor,
      },
      _active: {
        backgroundColor: ActiveBackgroundColor,
      },
    },
    titleText: {
      color: TextColor,
      textStyle: textStyleKeys.Body2,
      lineHeight: '0.875rem',
    },
    subtitleText: {
      color: TextColor,
      textStyle: textStyleKeys.Body3,
      lineHeight: '0.875rem',
    },
    doNotDisturbIcon: {
      height: '1.125rem',
      width: '1.125rem',
      color: ReceivingCallsIconColor,
    },
    chevronIcon: {
      height: '0.75rem',
      width: '0.75rem',
      color: TextColor,
    },
  },
  variants: {
    [DoNotDisturbSplitButtonVariants.DoNotDisturb]: {
      leftButton: {
        backgroundColor: OnBackgroundColor,
        _hover: {
          backgroundColor: OnHoverBackgroundColor,
        },
        _active: {
          backgroundColor: OnActiveBackgroundColor,
        },
      },
      rightButton: {
        backgroundColor: OnBackgroundColor,
        _hover: {
          backgroundColor: OnHoverBackgroundColor,
        },
        _active: {
          backgroundColor: OnActiveBackgroundColor,
        },
      },
      titleText: {
        textStyle: textStyleKeys.Body2_Semibold,
        color: OnTextColor,
      },
      subtitleText: {
        color: OnTextColor,
      },
      doNotDisturbIcon: {
        color: OnTextColor,
      },
      chevronIcon: {
        color: OnTextColor,
      },
    },
  },
})

export const useDoNotDisturbSplitButtonStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof DoNotDisturbSplitButtonStyleParts>(
    getName({ DoNotDisturbSplitButtonStyle }),
    props,
  )
}
